export * from 'server/models/RotationDashboard';


// WEBPACK FOOTER //
// ./data/models/RotationDashboard.ts